// extracted by mini-css-extract-plugin
module.exports = {"base-layout":"index_base-layout__Qp5y1","logo":"index_logo__SwQCq"};